import { render } from "./MaterialChartReport.vue?vue&type=template&id=4189c521&scoped=true"
import script from "./MaterialChartReport.vue?vue&type=script&lang=js"
export * from "./MaterialChartReport.vue?vue&type=script&lang=js"

import "./MaterialChartReport.vue?vue&type=style&index=0&id=4189c521&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4189c521"]])

export default __exports__